// ENTITY com.ic2.entity.UserConfig generated by ic2 4.0.0-SNAPSHOT at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class UserConfig {

  static readonly __ic2_fqn: string = 'com.ic2.entity.UserConfig';

  idConfig: number | null = 0;
  idUser: number | null = 0;
  cle: string | null = '';
  valeur: string | null = '';

  constructor(init?:Partial<UserConfig>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['com.ic2.entity.UserConfig'] = UserConfig;

fields['com.ic2.entity.UserConfig']  = {
    idConfig: 'java.lang.Integer',
    idUser: 'java.lang.Integer',
    cle: 'java.lang.String',
    valeur: 'java.lang.String'
};
